module.exports = __webpack_public_path__ + "31ff820b8c3c10391b65000a01d15f99.jpg";